import React, { Component } from 'react';
import { connect } from 'react-redux';
import { updateCustomerCore } from '../modules/update_customer_actions';
import { logoutStore } from '../modules/is_logged_in';

class CustomerCore extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isEditOpen:    false,
      core:          {}
    };

    this.toggleEditState    = this.toggleEditState.bind(this);
    this.handleChange       = this.handleChange.bind(this);
    this.updateCustomerCore = this.updateCustomerCore.bind(this);
  }

  toggleEditState() {
    this.setState({isEditOpen: !this.state.isEditOpen});
  }

  // Store updates in state so we can pass to update method
  handleChange( sType, event ) {
    let oUpdate      =  this.state.core;
    oUpdate[sType] = event.target.value;
    this.setState({core: oUpdate});
  }

  updateCustomerCore( evt ) {
    evt.preventDefault();

    let oUpdate = this.state.core;
    this.props.dispatch( updateCustomerCore( oUpdate ) );
    this.toggleEditState();
  }

  render() {
    let oCustomerData = [];
    // Ensure we have data.
    if ( this.props.customer && this.props.customer.id && this.props.customer.sap_account_number ) {
      oCustomerData = (
        <div className="section" id="core-info">
          <span className="button btn-primary mobile-420-show logout float-right" onClick={() => this.props.dispatch(logoutStore())}>Log Out</span>
          <h4 className="alt">Settings</h4>
          <ul className={"list" + (this.state.isEditOpen ? " hidden" : "")}>
            <li>Account#: {this.props.customer.sap_account_number}</li>
            <li>Name: {this.props.customer.first_name + " " + this.props.customer.last_name}</li>
            <li>Email: {this.props.customer.email}</li>
            <li>Password: &bull;&bull;&bull;&bull;&bull;&bull;&bull;&bull;</li>
            <li><span className="edit-link" onClick={this.toggleEditState}>edit</span></li>
          </ul>

          <div className={"info-edit-form" + (this.state.isEditOpen ? " showing" : "")} id="user-info-edit">
            <form name="customerCore" onSubmit={this.updateCustomerCore.bind( this )}>
              <input
                type         = "email"
                onChange     = {this.handleChange.bind( this, 'email' )}
                placeholder  = "Email"
                name         = "email"
                defaultValue = {this.props.customer.email}
              />
              <input
                type         = "text"
                onChange     = {this.handleChange.bind( this, 'first_name' )}
                placeholder  = "First Name"
                name         = "fname"
                defaultValue = {this.props.customer.first_name}
              />
              <input
                type         = "text"
                onChange     = {this.handleChange.bind( this, 'last_name' )}
                placeholder  = "Last Name"
                name         = "lname"
                defaultValue = {this.props.customer.last_name}
              />
              <input
                type         = "password"
                onChange     = {this.handleChange.bind( this, 'password' )}
                name         = "password"
                placeholder  = "Password"
              />
              <button className="btn-primary">update</button>
              <span className="button btn-tertiary cancel" onClick={this.toggleEditState}>cancel</span>
            </form>
          </div>
        </div>
      );
    }
    return(
      <div className="section" id="core-info">
        {oCustomerData}
      </div>
    );
  }
};

function mapStateToProps(state){
    return { 'customer': state.customer };
}

export default connect(mapStateToProps)(CustomerCore);


// WEBPACK FOOTER //
// ./src/components/CustomerCore.jsx